import type {Prize} from 'services/prizes/types';
import type {Schemas} from 'api/dto.generated';
import type {SearchResult} from 'api/searchTypes';
import {mapGetPrizeDto} from 'services/prizes';

export const mapPrizeSearchDto = (
  query: string,
  dto: Schemas.LiteraturePrizesPageResponse,
): SearchResult<Prize> => {
  return {
    hits: dto.items.map(mapGetPrizeDto),
    highlights: [query],
    total: dto.totalElements,
  };
};
